import {
  IbrandCatalogFilterAPIBody,
  IgetSalesMatchingData,
  IgetSalesMatchingDataItem,
} from 'api/endpoints/salesMatching/salesMatching.response.interface';
import * as SalesMatchingTypes from './salesMatching.types';
import {
  IInitialSalesMatchingState,
  IsalesMatchingOptions,
  IsalesMatchingToUpdateItem,
} from 'interfaces/salesMatching.interface';
import { ITableColumnsSelectOrderState } from 'interfaces/tables.interface';

export type TsalesMatchingDispatchReducer =
  | {
      type: typeof SalesMatchingTypes.SET_CATALOG_ITEMS;
      payload: IgetSalesMatchingData;
    }
  | {
      type: typeof SalesMatchingTypes.ADD_TO_SALES_MATCHING_TO_UPDATE;
      payload: Array<IsalesMatchingToUpdateItem>;
    }
  | {
      type: typeof SalesMatchingTypes.SET_SALES_MATCHING_TO_UPDATE_BODY;
      payload: IbrandCatalogFilterAPIBody;
    }
  | {
      type: typeof SalesMatchingTypes.SET_IS_LOADING_ADD_TO_SALES_MATCHING_TO_UPDATE;
      payload: {
        saleId: string | null;
        isLoading: boolean;
      };
    }
  | {
      type: typeof SalesMatchingTypes.SET_IS_LOADING_CATALOG;
      payload: boolean;
    }
  | {
      type: typeof SalesMatchingTypes.SET_REFERENCES_OPTIONS;
      payload: IsalesMatchingOptions;
    }
  | {
      type: typeof SalesMatchingTypes.SET_COLUMNS_ORDER;
      payload: Record<string, ITableColumnsSelectOrderState>;
    }
  | {
      type: typeof SalesMatchingTypes.SET_SALES_MATCHING_ITEMS_SELECTED;
      payload: Array<IgetSalesMatchingDataItem>;
    }
  | {
      type: typeof SalesMatchingTypes.SET_IS_LOADING_UNMATCH_SALES;
      payload: boolean;
    };

export default function salesMatchingReducer(
  state: IInitialSalesMatchingState,
  action: TsalesMatchingDispatchReducer
) {
  const { type, payload } = action;

  switch (type) {
    case SalesMatchingTypes.SET_CATALOG_ITEMS: {
      const getCatalogItems: IInitialSalesMatchingState = {
        ...state,
        salesMatchingItems: payload,
      };
      return getCatalogItems;
    }

    case SalesMatchingTypes.ADD_TO_SALES_MATCHING_TO_UPDATE: {
      const addToSalesMatchingToUpdate: IInitialSalesMatchingState = {
        ...state,
        salesMatchingToUpdate: payload,
      };
      return addToSalesMatchingToUpdate;
    }

    case SalesMatchingTypes.SET_SALES_MATCHING_TO_UPDATE_BODY: {
      const setSalesMatchingToUpdateBody: IInitialSalesMatchingState = {
        ...state,
        salesMatchingToUpdateBody: payload,
      };
      return setSalesMatchingToUpdateBody;
    }

    case SalesMatchingTypes.SET_IS_LOADING_ADD_TO_SALES_MATCHING_TO_UPDATE: {
      const setIsLoadingAddToSalesMatchingToUpdate: IInitialSalesMatchingState = {
        ...state,
        isLoadingAddToSalesMatchingToUpdate: payload,
      };
      return setIsLoadingAddToSalesMatchingToUpdate;
    }

    case SalesMatchingTypes.SET_IS_LOADING_CATALOG: {
      const setIsLoadingCatalog: IInitialSalesMatchingState = {
        ...state,
        isLoadingSalesMatchingItems: payload,
      };
      return setIsLoadingCatalog;
    }

    case SalesMatchingTypes.SET_REFERENCES_OPTIONS: {
      const setIsLoadingUpdateReferences: IInitialSalesMatchingState = {
        ...state,
        options: payload,
      };
      return setIsLoadingUpdateReferences;
    }

    case SalesMatchingTypes.SET_COLUMNS_ORDER: {
      const setColumnsOrder: IInitialSalesMatchingState = {
        ...state,
        columnsOrder: payload,
      };
      return setColumnsOrder;
    }

    case SalesMatchingTypes.SET_SALES_MATCHING_ITEMS_SELECTED: {
      const setSalesMatchingItemsSelected: IInitialSalesMatchingState = {
        ...state,
        salesMatchingItemsSelected: payload,
      };
      return setSalesMatchingItemsSelected;
    }

    case SalesMatchingTypes.SET_IS_LOADING_UNMATCH_SALES: {
      const setIsLoadingUnmatchSales: IInitialSalesMatchingState = {
        ...state,
        isLoadingUnmatchSales: payload,
      };
      return setIsLoadingUnmatchSales;
    }

    default:
      return state;
  }
}
